__turbopack_context__.v({
  "card": "login-module__WEZH7G__card",
  "cardBottom": "login-module__WEZH7G__cardBottom",
  "cardTop": "login-module__WEZH7G__cardTop",
  "errorMessage": "login-module__WEZH7G__errorMessage",
  "footer": "login-module__WEZH7G__footer",
  "forgotPasswordRow": "login-module__WEZH7G__forgotPasswordRow",
  "formSection": "login-module__WEZH7G__formSection",
  "ghostButton": "login-module__WEZH7G__ghostButton",
  "infoLine": "login-module__WEZH7G__infoLine",
  "infoTitle": "login-module__WEZH7G__infoTitle",
  "linkButton": "login-module__WEZH7G__linkButton",
  "loginContainer": "login-module__WEZH7G__loginContainer",
  "logo": "login-module__WEZH7G__logo",
  "primaryButton": "login-module__WEZH7G__primaryButton",
  "resendRow": "login-module__WEZH7G__resendRow",
  "resendTimer": "login-module__WEZH7G__resendTimer",
  "sectionGroup": "login-module__WEZH7G__sectionGroup",
  "sectionLabel": "login-module__WEZH7G__sectionLabel",
  "sectionText": "login-module__WEZH7G__sectionText",
  "sentDescription": "login-module__WEZH7G__sentDescription",
  "sentEmail": "login-module__WEZH7G__sentEmail",
  "sentIcon": "login-module__WEZH7G__sentIcon",
  "sentTitle": "login-module__WEZH7G__sentTitle",
  "sentView": "login-module__WEZH7G__sentView",
  "socialButton": "login-module__WEZH7G__socialButton",
  "socialRow": "login-module__WEZH7G__socialRow",
  "title": "login-module__WEZH7G__title",
  "viewContent": "login-module__WEZH7G__viewContent",
});
